import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { VirtualSportQueryKeys } from "./virtualSportQueryKeys";
import {
  DEFAULT_VIRTUAL_SPORT_TYPE,
  getVirtualRounds,
  VirtualSportType,
} from "@/api/virtualSport";

// VR league/round metadata (per league: currentRound, totalRounds, open betting
// weeks). One shared query per sport feeds every VR view that needs the round
// state.
export const useVirtualRounds = (
  sportType: VirtualSportType = DEFAULT_VIRTUAL_SPORT_TYPE
) =>
  useQuery({
    queryKey: [VirtualSportQueryKeys.Rounds, sportType],
    queryFn: () => getVirtualRounds(sportType),
    refetchInterval: 3000,
    // Keep the previous data during refetch / brief round-transition gaps so the
    // league tabs don't flicker (disappear then reappear).
    placeholderData: keepPreviousData,
  });
